import React, { useEffect, useMemo, useRef, useState } from 'react';
import './AcademyGuide.css';
import './AtmGuide.css';

export const ATM_HASH = '#atm10';
const CHECK_KEY = 'atm10-checklist';

/* ——— Contenu (All the Mods 10, version 8.4 — Minecraft 1.21.1, NeoForge) ——— */
const CHAPTERS = [
  { id: 'bienvenue', n: '01', title: 'Bienvenue', sub: 'Le concept et le but final' },
  { id: 'installer', n: '02', title: 'Installer', sub: 'Launcher, RAM, connexion' },
  { id: 'premiers-jours', n: '03', title: 'Premiers jours', sub: 'L’ordre conseillé' },
  { id: 'commandes', n: '04', title: 'Commandes & claims', sub: 'Équipe, homes, chunks' },
  { id: 'energie', n: '05', title: 'Énergie', sub: 'Du vent aux réacteurs' },
  { id: 'minerais', n: '06', title: 'Minerais ATM', sub: 'Allthemodium → Unobtainium' },
  { id: 'dimensions', n: '07', title: 'Dimensions', sub: 'Pad, Mining, The Other, Beyond' },
  { id: 'etoile', n: '08', title: 'L’ATM Star', sub: 'Le défi de fin de partie' },
  { id: 'astuces', n: '09', title: 'Astuces', sub: 'Gagner des heures' }
];

const FIRST_DAYS = [
  { t: 'Bois, établi… et l’établi sur un bâton', d: 'Le « Crafting Table on a Stick » est un établi portable : mets-le dans un emplacement Curios et assigne-lui une touche.' },
  { t: 'Crée ou rejoins une équipe', d: '/ftbteams party create <nom> : vos claims, vos quêtes et vos chunks sont partagés.' },
  { t: 'Claim ta base', d: 'Ouvre la carte (M), puis l’icône des chunks claimés en haut à gauche : clic gauche glissé pour claim.' },
  { t: 'Fer, cuivre, et un marteau à minerai', d: 'Le marteau transforme 1 minerai brut en 2 poudres : tu doubles tes lingots dès le début.' },
  { t: 'Améliore tes fours', d: 'Iron Furnaces : plus rapides, avec des augmentations et l’entrée/sortie automatique sur les côtés.' },
  { t: 'Un sac à dos et des Waystones', d: 'Sophisticated Backpacks (avec l’amélioration aimant) et active chaque Waystone que tu croises.' },
  { t: 'Ta première énergie', d: 'Une éolienne Mekanism, le plus haut possible : de l’énergie gratuite, jour et nuit.' },
  { t: 'Diamant, puis Nether', d: 'Pioche en diamant → obsidienne → portail. Le Nether ouvre la route du Netherite… et de l’Allthemodium.' }
];

const COMMANDS = [
  ['/ftbteams party create <nom>', 'Créer une équipe avec tes amis (claims et quêtes partagés).'],
  ['/sethome <nom>', 'Enregistrer un home (ex. /sethome ferme), puis /home ferme pour y revenir.'],
  ['/home <nom>', 'Te téléporter à un home, dans n’importe quelle dimension.'],
  ['/back', 'Revenir à ta position précédente ou à ton point de mort.'],
  ['/spawn', 'Retour au spawn de l’Overworld.'],
  ['/rtp', 'Téléportation aléatoire pour trouver un coin tranquille.'],
  ['/tpa <joueur>', 'Demander à te téléporter vers un ami.']
];

const POWER = [
  { t: 'Éolienne', m: 'Mekanism', d: 'Gratuite, jour et nuit. Plus elle est haute, plus elle produit.', lvl: 1 },
  { t: 'Panneaux solaires', m: 'Mekanism · Powah', d: 'Aucune ressource, mais uniquement de jour.', lvl: 1 },
  { t: 'Générateurs à lave', m: 'Generators Galore · Powah', d: 'Ta lave du Nether devient de l’énergie.', lvl: 2 },
  { t: 'Réacteurs Powah', m: 'Powah', d: 'Uraninite + refroidissement : un gros saut de production.', lvl: 3 },
  { t: 'Extreme Reactors & fission', m: 'Extreme Reactors · Mekanism', d: 'Des multiblocs pour la fin de partie et l’ATM Star.', lvl: 4 }
];

const TIERS = [
  {
    id: 'atm', name: 'Allthemodium', color: '#ffc93c', deep: '#7a4b00', pick: 'Netherite',
    where: ['Overworld : murs des grottes autour des Cités antiques et biomes Deep Dark (le minerai brille, mais il est rare).', 'Mining Dimension : couches de Y 65 à 128.'],
    template: 'Modèle de forge : argile suspecte à brosser au sol des Cités antiques.',
    note: 'Bonus de quête : tuer le Warden donne un lingot.'
  },
  {
    id: 'vib', name: 'Vibranium', color: '#47e3a0', deep: '#0b5a3c', pick: 'Allthemodium',
    where: ['Le Nether, rare (Y 64 à 127, souvent à l’air libre).', 'The Other, en abondance (Y 0 à 40).'],
    template: 'Modèle de forge : sable des âmes suspect à brosser dans les Bastions.',
    note: 'C’est le minerai ATM qui sert le moins : garde-le pour les alliages.'
  },
  {
    id: 'unob', name: 'Unobtainium', color: '#c26bff', deep: '#43136e', pick: 'Vibranium',
    where: ['L’End, uniquement dans les End Highlands (là où apparaissent les End Cities). Très rare.', 'Non, il n’est pas dans The Beyond !'],
    template: 'Modèle de forge : en battant les Trial Spawners des bibliothèques du Donjon de The Other.',
    note: 'L’armure complète : 40 points d’armure, 60 de robustesse, 90 % de résistance à la magie.'
  }
];

const DIMS = [
  {
    id: 'mining', from: 'Overworld', to: 'Mining Dimension', color: '#ffc93c',
    d: 'Un monde superplat : rien en surface, et presque tous les minerais du pack en dessous. Pas de grottes, pas de mobs. Le paradis des quarries… mais elles détruisent l’Allthemodium au lieu de le récolter.',
    tip: 'Pour l’Allthemodium, mine à la main avec une potion de vision des minerais (Ore Sight).'
  },
  {
    id: 'other', from: 'Nether', to: 'The Other', color: '#47e3a0',
    d: 'La dimension d’aventure : biomes inédits, Village Piglin, Pyramide antique et Donjon, avec des structures de When Dungeons Arise et d’Ice and Fire. Vibranium à foison et lave des âmes dans les villages.',
    tip: 'Pas de quarry possible sur la plupart des blocs. Emporte des blocs de lumière : les spawners y sont nombreux.'
  },
  {
    id: 'beyond', from: 'The End', to: 'The Beyond', color: '#c26bff',
    d: '« Bienvenue dans The Beyond ! Il n’y a rien ici. » Un grand vide, idéal pour construire en paix, loin de tout.',
    tip: 'Prévois un Angel Block (un bloc qui se pose dans le vide) avant d’y aller.'
  }
];

const STAR_PARTS = [
  { id: 'top', name: 'Branche du haut', x: 50, y: 6 },
  { id: 'right', name: 'Branche de droite', x: 94, y: 38 },
  { id: 'br', name: 'Branche bas droite', x: 77, y: 92 },
  { id: 'bl', name: 'Branche bas gauche', x: 23, y: 92 },
  { id: 'left', name: 'Branche de gauche', x: 6, y: 38 }
];

const STAR_MODS = [
  'Mekanism', 'Applied Energistics 2', 'Create', 'Ars Nouveau', 'Mystical Agriculture', 'Productive Bees', 'Productive Trees',
  'Industrial Foregoing', 'Occultism', 'Powah', 'Extreme Reactors', 'Forbidden & Arcanus', 'Eternal Starlight', 'Cataclysm',
  'Twilight Forest', 'Iron’s Spells', 'EvilCraft', 'PneumaticCraft', 'Modern Industrialization', 'Oritech', 'Immersive Engineering',
  'Just Dire Things', 'Hostile Neural Networks', 'Deeper and Darker', 'Iron Furnaces', 'Generators Galore', 'Apotheosis', 'Allthemodium'
];

const TIPS = [
  ['Vein Miner', 'Touche ² (ou `) en minant : tout le filon, l’arbre ou le groupe de blocs part d’un coup. Maj + molette pour changer de forme (tunnel, escalier…).'],
  ['Les quêtes sont optionnelles', 'Aucun mod n’est bloqué. Les chapitres de quêtes servent surtout de guides : la quête principale, elle, mène jusqu’à l’ATM Star.'],
  ['JEI est ton meilleur ami', 'R sur un objet : sa recette. U : à quoi il sert. Avec plus de 500 mods, c’est indispensable.'],
  ['Silent Gear', 'Des outils modulables qui ne cassent jamais : à 0 de durabilité ils se désactivent, et se réparent à l’infini.'],
  ['Nature’s & Explorer’s Compass', 'Pour trouver un biome précis ou une structure (Bastion, Cité antique, donjons de Cataclysm…).'],
  ['Double tes minerais', 'Marteaux au début, puis Occultism, Mekanism… Chaque palier de traitement rapporte plus de lingots par minerai.'],
  ['Les outils ATM s’améliorent', 'On n’en crafte plus : on améliore son équipement en Netherite. Il garde ses enchantements et se répare.'],
  ['Stockage', 'Sophisticated Storage pour la base, puis AE2 ou Refined Storage dès que tu croules sous les coffres.']
];

/* ——— Petits composants ——— */

/** Bloc de minerai en pixel art généré (pierre + éclats de couleur), toujours le même pour une graine donnée. */
const Ore = ({ color = '#ffc93c', deep = '#7a4b00', seed = 1, size = 64, stone = 'deepslate' }) => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    c.width = 16; c.height = 16;
    const x = c.getContext('2d');
    let s = seed * 9301 + 49297;
    const rnd = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
    const base = stone === 'end' ? ['#e9e5b0', '#d8d39a', '#f4f1c8'] : stone === 'nether' ? ['#5a2222', '#4a1a1a', '#6b2b2b'] : ['#4a4a55', '#3c3c46', '#57575f'];
    for (let i = 0; i < 16; i += 1) for (let j = 0; j < 16; j += 1) { x.fillStyle = base[Math.floor(rnd() * 3)]; x.fillRect(i, j, 1, 1); }
    for (let k = 0; k < 6; k += 1) {
      const cx = 2 + Math.floor(rnd() * 12);
      const cy = 2 + Math.floor(rnd() * 12);
      [[0, 0], [1, 0], [0, 1], [1, 1]].forEach(([dx, dy]) => { if (rnd() > 0.25) { x.fillStyle = color; x.fillRect(cx + dx, cy + dy, 1, 1); } });
      x.fillStyle = deep; x.fillRect(cx + 1, cy + 1, 1, 1);
      x.fillStyle = '#ffffff'; if (rnd() > 0.5) x.fillRect(cx, cy, 1, 1);
    }
  }, [color, deep, seed, stone]);
  return <canvas ref={ref} className="atm-ore" style={{ width: size, height: size, '--glow': color }} aria-hidden="true" />;
};

/** Nombre qui défile jusqu'à sa valeur quand il apparaît. */
const CountUp = ({ to, suffix = '' }) => {
  const ref = useRef(null);
  const [v, setV] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let raf = 0;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - t0) / 1100);
        setV(Math.round(to * (1 - (1 - k) ** 3)));
        if (k < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }, { threshold: 0.4 });
    io.observe(el);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, [to]);
  return <span ref={ref}>{v.toLocaleString('fr-FR')}{suffix}</span>;
};

const Section = ({ ch, children, lead }) => (
  <section id={ch.id} className="acad-section" data-chapter={ch.id}>
    <header className="acad-section-head">
      <span className="acad-num" aria-hidden="true">{ch.n}</span>
      <div>
        <h2>{ch.title}</h2>
        {lead && <p className="acad-lead">{lead}</p>}
      </div>
    </header>
    {children}
  </section>
);

const Tip = ({ children }) => <aside className="acad-tip"><b>Astuce</b><span>{children}</span></aside>;

/* ——— Blocs interactifs ——— */

const Checklist = () => {
  const [done, setDone] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CHECK_KEY) || '[]'); } catch { return []; }
  });
  const toggle = (k) => setDone((prev) => {
    const next = prev.includes(k) ? prev.filter((v) => v !== k) : [...prev, k];
    try { localStorage.setItem(CHECK_KEY, JSON.stringify(next)); } catch { /* stockage indisponible */ }
    return next;
  });
  const pct = Math.round((done.length / FIRST_DAYS.length) * 100);
  return (
    <div className="acad-check">
      <div className="acad-check-bar"><b style={{ width: `${pct}%` }} /><span>{done.length} / {FIRST_DAYS.length} fait{done.length > 1 ? 's' : ''}</span></div>
      <ol>
        {FIRST_DAYS.map((s, k) => (
          <li key={s.t} className={done.includes(k) ? 'is-done' : ''}>
            <button type="button" onClick={() => toggle(k)} aria-pressed={done.includes(k)}>
              <i aria-hidden="true">{done.includes(k) ? '✓' : k + 1}</i>
              <span><b>{s.t}</b><small>{s.d}</small></span>
            </button>
          </li>
        ))}
      </ol>
      {pct === 100 && <p className="acad-check-done">Base posée, énergie qui tourne : direction le Nether !</p>}
    </div>
  );
};

const Commands = () => {
  const [copied, setCopied] = useState(null);
  const copy = (cmd) => {
    try { navigator.clipboard?.writeText(cmd.replace(/ <.*>$/, ' ')); } catch { /* presse-papiers indisponible */ }
    setCopied(cmd);
    setTimeout(() => setCopied((c) => (c === cmd ? null : c)), 1400);
  };
  return (
    <div className="acad-cmds">
      {COMMANDS.map(([cmd, what]) => (
        <button key={cmd} type="button" className={`acad-cmd${copied === cmd ? ' is-copied' : ''}`} onClick={() => copy(cmd)} title="Copier la commande">
          <code>{cmd}</code>
          <span>{what}</span>
          <em>{copied === cmd ? 'Copié !' : 'Copier'}</em>
        </button>
      ))}
    </div>
  );
};

/** L'échelle des minerais : chaque palier se mine avec la pioche du palier d'avant. */
const TierLadder = () => {
  const [i, setI] = useState(0);
  const t = TIERS[i];
  return (
    <div className="atm-tiers acad-reveal" style={{ '--c': t.color }}>
      <div className="atm-ladder" role="tablist" aria-label="Minerais ATM">
        <div className="atm-step is-base"><span className="atm-step-pick">Netherite</span><small>le point de départ</small></div>
        {TIERS.map((tier, k) => (
          <React.Fragment key={tier.id}>
            <span className="atm-arrow" aria-hidden="true">→</span>
            <button type="button" role="tab" aria-selected={k === i} className={`atm-step${k === i ? ' is-on' : ''}${k < i ? ' is-done' : ''}`} style={{ '--c': tier.color }} onClick={() => setI(k)}>
              <Ore color={tier.color} deep={tier.deep} seed={k + 3} size={52} stone={k === 1 ? 'nether' : k === 2 ? 'end' : 'deepslate'} />
              <span>{tier.name}</span>
            </button>
          </React.Fragment>
        ))}
      </div>
      <div className="atm-tier-card" key={t.id}>
        <div className="atm-tier-head">
          <Ore color={t.color} deep={t.deep} seed={i + 11} size={84} stone={i === 1 ? 'nether' : i === 2 ? 'end' : 'deepslate'} />
          <div>
            <h3>{t.name}</h3>
            <p className="atm-pick">Pioche nécessaire : <b>{t.pick}</b> ou mieux</p>
          </div>
        </div>
        <h4>Où le trouver</h4>
        <ul className="acad-bullets">{t.where.map((w) => <li key={w}>{w}</li>)}</ul>
        <h4>Améliorer ton équipement</h4>
        <p>{t.template}</p>
        <p className="acad-muted">{t.note}</p>
      </div>
    </div>
  );
};

/** Le Teleport Pad : la même dalle, trois destinations selon la dimension où tu la poses. */
const Dimensions = () => {
  const [i, setI] = useState(0);
  const d = DIMS[i];
  return (
    <div className="atm-dims acad-reveal" style={{ '--c': d.color }}>
      <div className="atm-pad">
        <div className="atm-pad-recipe">
          <span className="atm-chip">4 pépites d’Allthemodium</span><span className="atm-op">+</span><span className="atm-chip">1 perle de l’Ender</span><span className="atm-op">=</span><span className="atm-chip is-on">Teleport Pad</span>
        </div>
        <p>Pose-le, puis <b>Maj + clic droit, les deux mains vides</b>. Oui, les deux : c’est l’erreur numéro un.</p>
      </div>
      <div className="atm-dim-tabs" role="tablist" aria-label="Dimension de départ">
        {DIMS.map((x, k) => (
          <button key={x.id} type="button" role="tab" aria-selected={k === i} className={k === i ? 'is-on' : ''} style={{ '--c': x.color }} onClick={() => setI(k)}>
            <small>Posé dans</small><b>{x.from}</b>
          </button>
        ))}
      </div>
      <div className="atm-dim-card" key={d.id}>
        <span className="atm-dim-route">{d.from} <i aria-hidden="true">⟶</i> <b>{d.to}</b></span>
        <p>{d.d}</p>
        <Tip>{d.tip}</Tip>
      </div>
    </div>
  );
};

/** L'ATM Star : cinq branches + les éclats d'étoile, qui demandent presque tous les mods du pack. */
const Star = () => {
  const [on, setOn] = useState(null);
  return (
    <div className="atm-star-wrap acad-reveal">
      <div className="atm-star" aria-label="Les parties de l’ATM Star">
        <svg viewBox="0 0 100 100" aria-hidden="true">
          <defs>
            <linearGradient id="atm-star-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#fff6c2" /><stop offset=".5" stopColor="#ffc93c" /><stop offset="1" stopColor="#c26bff" /></linearGradient>
          </defs>
          <polygon points="50,4 61,37 96,37 68,58 79,93 50,72 21,93 32,58 4,37 39,37" fill="url(#atm-star-g)" stroke="#08164d" strokeWidth="2.5" strokeLinejoin="round" />
        </svg>
        {STAR_PARTS.map((p) => (
          <button key={p.id} type="button" className={`atm-star-dot${on === p.id ? ' is-on' : ''}`} style={{ left: `${p.x}%`, top: `${p.y}%` }} onClick={() => setOn(on === p.id ? null : p.id)} aria-label={p.name} />
        ))}
        <span className="atm-star-core">ATM</span>
      </div>
      <div className="atm-star-side">
        <h3>{on ? STAR_PARTS.find((p) => p.id === on).name : 'Cinq branches, un cœur'}</h3>
        <p>{on
          ? 'Chaque branche a sa propre quête dans le chapitre « The ATM Star », avec sa recette exacte. Elles passent par des multiblocs dédiés : Runic Crucible, Forge d’Héphaïstos automatique, Autel de l’étoile runique…'
          : 'L’étoile s’assemble à partir de cinq branches et d’éclats d’étoile. Clique sur une branche pour voir comment ça se passe.'}</p>
        <ul className="atm-star-facts">
          <li><b><CountUp to={100} suffix="+" /></b><span>quêtes dans le chapitre « The Star »</span></li>
          <li><b><CountUp to={36} /></b><span>quêtes rien que pour assembler l’étoile</span></li>
        </ul>
      </div>
    </div>
  );
};

/* ——— Page ——— */
const PARADE = [
  ['#ffc93c', '#7a4b00', 'deepslate'], ['#47e3a0', '#0b5a3c', 'nether'], ['#c26bff', '#43136e', 'end'], ['#7fe7ff', '#1b6a86', 'deepslate'],
  ['#ff6a5a', '#7a1a12', 'deepslate'], ['#ffc93c', '#7a4b00', 'deepslate'], ['#9fb3ff', '#2b3c8a', 'deepslate'], ['#47e3a0', '#0b5a3c', 'nether'],
  ['#ff9ad6', '#7a2052', 'deepslate'], ['#c26bff', '#43136e', 'end']
];

const AtmGuide = ({ onClose }) => {
  const [active, setActive] = useState(CHAPTERS[0].id);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const sections = [...document.querySelectorAll('.acad-section')];
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.dataset.chapter); });
    }, { rootMargin: '-35% 0px -55% 0px' });
    sections.forEach((s) => io.observe(s));
    const reveal = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); reveal.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.acad-reveal').forEach((el) => reveal.observe(el));
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(h > 0 ? window.scrollY / h : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => { io.disconnect(); reveal.disconnect(); window.removeEventListener('scroll', onScroll); };
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 24, behavior: 'smooth' });
  };
  const activeIdx = useMemo(() => CHAPTERS.findIndex((c) => c.id === active), [active]);
  const navRef = useRef(null);
  useEffect(() => {
    const list = navRef.current?.querySelector('ol');
    const btn = list?.querySelector('.is-on');
    if (list && btn && list.scrollWidth > list.clientWidth) list.scrollTo({ left: btn.offsetLeft - list.clientWidth / 2 + btn.clientWidth / 2, behavior: 'smooth' });
  }, [active]);

  return (
    <div className="acad atm">
      <div className="acad-progress" aria-hidden="true"><b style={{ transform: `scaleX(${progress})` }} /></div>

      <header className="acad-hero">
        <div className="acad-hero-top">
          <span className="acad-kicker">Bully’s Lair · serveur Minecraft</span>
          <button type="button" className="acad-back" onClick={onClose}>Retour</button>
        </div>
        <div className="acad-hero-main">
          <p className="acad-hero-pre">Le guide du joueur</p>
          <h1 className="acad-title">
            <span>All the Mods</span>
            <span><em>10</em></span>
          </h1>
          <p className="acad-hero-text">Le modpack « fourre-tout » par excellence : magie, technologie, exploration, automatisation… Tu joues comme tu veux. Ce guide t’aide à bien démarrer, à grimper les paliers de minerais et à viser le grand défi : l’ATM Star.</p>
          <ul className="acad-tags">
            <li>Minecraft 1.21.1</li>
            <li>NeoForge · ATM10 8.4</li>
            <li>500+ mods</li>
            <li>Objectif : l’ATM Star</li>
          </ul>
          <button type="button" className="acad-start" onClick={() => go('bienvenue')}>Commencer la lecture</button>
        </div>
        <div className="acad-parade" aria-hidden="true">
          <div className="acad-parade-track atm-parade">
            {[...PARADE, ...PARADE].map(([c, d, st], k) => <Ore key={k} color={c} deep={d} stone={st} seed={k + 1} size={k % 3 === 0 ? 76 : 60} />)}
          </div>
        </div>
      </header>

      <div className="acad-body">
        <nav className="acad-nav" aria-label="Sommaire" ref={navRef}>
          <span className="acad-nav-title">Au programme</span>
          <ol>
            {CHAPTERS.map((c, k) => (
              <li key={c.id}>
                <button type="button" className={`${c.id === active ? 'is-on' : ''}${k < activeIdx ? ' is-read' : ''}`} onClick={() => go(c.id)}>
                  <b>{c.n}</b><span>{c.title}<small>{c.sub}</small></span>
                </button>
              </li>
            ))}
          </ol>
        </nav>

        <main className="acad-main">
          {/* 01 */}
          <Section ch={CHAPTERS[0]} lead="ATM10 est un « kitchen sink » : des centaines de mods réunis, sans ordre imposé. Tu peux devenir mage, ingénieur, éleveur d’abeilles ou explorateur de dimensions… Mais il y a un but final pour ceux qui veulent tout voir : fabriquer l’ATM Star.">
            <div className="acad-stats acad-reveal">
              <div><strong><CountUp to={500} suffix="+" /></strong><span>mods, de Mekanism à Ars Nouveau</span></div>
              <div><strong><CountUp to={60} suffix="+" /></strong><span>chapitres de quêtes qui servent de guides</span></div>
              <div><strong><CountUp to={3} /></strong><span>paliers de minerais ATM après le Netherite</span></div>
              <div><strong><CountUp to={1} /></strong><span>but ultime : l’ATM Star</span></div>
            </div>
            <div className="acad-trio acad-reveal">
              <div className="acad-panel"><span className="acad-ico">⚙️</span><h3>Technologie</h3><p>Mekanism, Create, Applied Energistics 2, Industrial Foregoing, PneumaticCraft, Modern Industrialization, Oritech…</p></div>
              <div className="acad-panel"><span className="acad-ico">✨</span><h3>Magie</h3><p>Ars Nouveau, Occultism, Iron’s Spells, Forbidden &amp; Arcanus, EvilCraft, Theurgy, Mahou Tsukai…</p></div>
              <div className="acad-panel"><span className="acad-ico">🗺️</span><h3>Aventure</h3><p>Twilight Forest, Aether, Cataclysm, Ice and Fire, Eternal Starlight, Bumblezone, Undergarden…</p></div>
            </div>
            <Tip>Les quêtes ne bloquent rien : aucun mod n’est verrouillé. Suis la quête principale si tu veux un fil rouge, et pioche dans les autres chapitres comme dans des tutos.</Tip>
          </Section>

          {/* 02 */}
          <Section ch={CHAPTERS[1]} lead="ATM10 s’installe avec le launcher CurseForge (ou celui de FTB). Prends exactement la même version que le serveur, sinon la connexion est refusée.">
            <div className="atm-install acad-reveal">
              <div className="acad-panel"><span className="atm-n">1</span><h3>Installe le pack</h3><p>Dans CurseForge : Minecraft › Explorer les modpacks › cherche « ATM10 » › Installer.</p></div>
              <div className="acad-panel"><span className="atm-n">2</span><h3>Donne-lui de la RAM</h3><p>Paramètres › Minecraft › Mémoire allouée : vise 10 à 12 Go si ton PC le permet (8 Go minimum).</p></div>
              <div className="acad-panel"><span className="atm-n">3</span><h3>Lance une première fois</h3><p>Le premier démarrage est long : c’est normal, il prépare plus de 500 mods.</p></div>
              <div className="acad-panel is-gold"><span className="atm-n">4</span><h3>Rejoins le serveur</h3><p>Multijoueur › Ajouter un serveur, avec l’adresse donnée sur le Discord de Bully’s Lair.</p></div>
            </div>
            <Tip>Écran tout noir ou objets invisibles ? Vérifie que ta version d’ATM10 est bien la même que celle du serveur avant de chercher plus loin.</Tip>
          </Section>

          {/* 03 */}
          <Section ch={CHAPTERS[2]} lead="Les premières heures décident de la suite. L’ordre conseillé : coche au fur et à mesure.">
            <Checklist />
          </Section>

          {/* 04 */}
          <Section ch={CHAPTERS[3]} lead="Joue en équipe, protège ta base et déplace-toi vite : tout passe par FTB Teams, FTB Chunks et FTB Essentials.">
            <h3 className="acad-h3">Commandes utiles <small>clique pour copier</small></h3>
            <Commands />
            <div className="acad-duo acad-reveal">
              <div className="acad-panel">
                <h3>Claim des chunks</h3>
                <p>Ouvre la carte avec <b>M</b>, puis l’icône des chunks claimés en haut à gauche. Clic gauche glissé pour claim : personne d’autre ne pourra casser ou ouvrir quoi que ce soit chez toi.</p>
              </div>
              <div className="acad-panel is-gold">
                <h3>Forcer le chargement</h3>
                <p><b>Maj + clic gauche</b> sur un chunk claimé : il reste chargé même quand tu n’es pas là. Des lignes apparaissent dessus quand c’est bon. Parfait pour tes machines.</p>
              </div>
            </div>
            <Tip>Les commandes ont des temps de recharge et des limites (nombre de homes…). Si une commande refuse, attends quelques secondes.</Tip>
          </Section>

          {/* 05 */}
          <Section ch={CHAPTERS[4]} lead="Presque tout le modpack tourne à l’énergie (FE). Commence petit, grimpe par paliers.">
            <div className="atm-power acad-reveal">
              {POWER.map((p) => (
                <div key={p.t} className="atm-power-row" style={{ '--lvl': p.lvl }}>
                  <div className="atm-power-bar"><b /></div>
                  <div><strong>{p.t}</strong><small>{p.m}</small><span>{p.d}</span></div>
                </div>
              ))}
            </div>
            <div className="acad-duo acad-reveal">
              <div className="acad-panel"><h3>Transporter</h3><p>Tuyaux d’énergie Pipez, câbles Powah, ou conduits EnderIO pour les nostalgiques.</p></div>
              <div className="acad-panel"><h3>Stocker</h3><p>Cellules d’énergie Powah (améliorables) ou les Powercells multiblocs de RFTools.</p></div>
            </div>
          </Section>

          {/* 06 */}
          <Section ch={CHAPTERS[5]} lead="Après le Netherite viennent les trois minerais du mod Allthemodium. Chaque palier se mine avec la pioche du palier précédent… et seulement par un vrai joueur : quarries et autres machines ne peuvent pas les récolter.">
            <TierLadder />
            <div className="acad-duo acad-reveal">
              <div className="acad-panel">
                <h3>Les alliages</h3>
                <p>En combinant deux minerais ATM, tu obtiens trois alliages : Vibranium-Allthemodium, Unobtainium-Allthemodium et Unobtainium-Vibranium. Ils passent par la Dissolution Chamber d’Industrial Foregoing ou l’Enchanting Apparatus d’Ars Nouveau, avec des cœurs de Piglich.</p>
              </div>
              <div className="acad-panel is-gold">
                <h3>L’armure Allthemodium</h3>
                <p>Respiration aquatique, immunité à l’obscurité du Warden, pas d’usure de l’élytre, 50 % de résistance à la magie, immunité au Wither, et tu marches sur la lave. Excusez du peu.</p>
              </div>
            </div>
            <Tip>Traite toujours tes minerais ATM (Fortune, Occultism, Mekanism) avant de les fondre : ils sont trop rares pour en perdre la moitié.</Tip>
          </Section>

          {/* 07 */}
          <Section ch={CHAPTERS[6]} lead="Avec tes premières pépites d’Allthemodium, fabrique deux Teleport Pads. La même dalle mène à trois dimensions différentes selon l’endroit où tu la poses.">
            <Dimensions />
            <div className="acad-panel is-red acad-reveal">
              <h3>Le Piglich</h3>
              <p>Le boss du mod Allthemodium vit dans la Pyramide antique de The Other. Il a 9 999 cœurs, et son cœur est indispensable pour les alliages et pour l’ATM Star. Pense à le farmer (Hostile Neural Networks, EnderIO…).</p>
            </div>
          </Section>

          {/* 08 */}
          <Section ch={CHAPTERS[7]} lead="L’ATM Star, c’est la fin de partie : un objet qui demande des éléments de presque tous les gros mods du pack. Le chapitre de quêtes « The Star » te guide pas à pas.">
            <Star />
            <h3 className="acad-h3">Les mods qui y passent</h3>
            <div className="atm-mods acad-reveal">{STAR_MODS.map((m) => <span key={m}>{m}</span>)}</div>
            <Tip>Ne la vise pas trop tôt : construis d’abord une vraie base automatisée (énergie, stockage AE2, traitement des minerais). L’étoile, c’est le marathon, pas le sprint.</Tip>
          </Section>

          {/* 09 */}
          <Section ch={CHAPTERS[8]} lead="Les petites choses qui changent tout.">
            <div className="acad-mechs atm-tips acad-reveal">
              {TIPS.map(([t, d]) => (
                <div key={t} className="acad-panel"><h3>{t}</h3><p>{d}</p></div>
              ))}
            </div>
          </Section>

          <footer className="acad-outro">
            <div className="acad-outro-mons" aria-hidden="true">
              <Ore color="#ffc93c" deep="#7a4b00" seed={91} size={96} />
              <Ore color="#47e3a0" deep="#0b5a3c" seed={92} size={110} stone="nether" />
              <Ore color="#c26bff" deep="#43136e" seed={93} size={96} stone="end" />
            </div>
            <h2 className="acad-outro-title">Bon jeu, et vise l’étoile !</h2>
            <p>Une question, un bug, une idée ? Parles-en sur le Discord. Le guide évolue avec le modpack.</p>
            <ul className="acad-motto"><li>Explore</li><li>Automatise</li><li>Grimpe les paliers</li><li>Forge l’étoile</li></ul>
            <button type="button" className="acad-back is-big" onClick={onClose}>Retour au site</button>
          </footer>
        </main>
      </div>
    </div>
  );
};

export default AtmGuide;
